import { ErrorDetails, NetworkStatusProvider, notFoundError } from 'features';
import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { CenteredLoader } from 'ui';

import {
  SignInEmail,
  SignInEmailVerify,
  SignInPhone,
  SignInPhoneVerify,
  SignUp,
  SignUpCompany,
  SignUpSuccess,
  SignUpVerify,
} from './auth';
import {
  BuyerMaterialSpecificationsAddPage,
  BuyerMaterialSpecificationsEditPage,
  BuyerMaterialSpecificationsListPage,
} from './buyer-material-specifications';
import { DealCostDetails, DealRevenueDetails } from './dealhub';
import { DocumentPage } from './document-generation';
import { GenerateDocumentPage } from './document-generation/pages/generate/Generate';
import { CopySessions, PhotoEvidenceView } from './evidence';
import { FinancingHome } from './financing';
import { GroundControl } from './ground-control';
import { ShipmentCreatePage, ShipmentUpdate } from './logistics';
import { MaterialProductCreate, MaterialProductDetails, MaterialProductsList } from './material-products';
import { Layout } from './navigation';
import { PurchaseOrderCreate, PurchaseOrderUpdate, SalesOrderCreate, SalesOrderUpdate } from './orders';
import { DealProfitabilityCalculator } from './profitability-calculator';
import { ExternalEvidence } from './quality';
import { CompanySiteMaterials, NewSiteMaterial, SiteMaterialUpdate } from './site-materials';
import { FindTickets, SupportTicketCreate } from './support-tickets';
import { TransportCostsEstimator } from './transport-costs';
export const Router = () => {
  return (
    <Routes>
      <Route
        path="/ground-control"
        element={
          <Layout>
            <Outlet />
          </Layout>
        }
      >
        <Route index element={<GroundControl />} />
        <Route path="document-generation">
          <Route index element={<GenerateDocumentPage />} />
          <Route path=":id" element={<DocumentPage />} />
        </Route>
        <Route path="profitability-calculator" element={<DealProfitabilityCalculator />} />
        <Route path="financing-home" element={<FinancingHome />} />
        <Route path="transport-costs">
          <Route path="estimate" element={<TransportCostsEstimator />} />
        </Route>
        <Route path="material-products">
          <Route index element={<MaterialProductsList />} />
          <Route path="create" element={<MaterialProductCreate />} />
          <Route path=":id" element={<MaterialProductDetails />} />
        </Route>
        <Route path="create-purchase-order" element={<PurchaseOrderCreate />} />
        <Route path="create_purchase_order" element={<Navigate to="/ground-control/create-purchase-order/?" />} />
        <Route path="purchase-order/:id/update" element={<PurchaseOrderUpdate />} />
        <Route path="v2">
          <Route path="create-sales-order" element={<SalesOrderCreate />} />
          <Route path="sales-order/:id/update" element={<SalesOrderUpdate />} />
          <Route path="shipment">
            <Route path="create">
              <Route path=":salesOrderSlug" element={<ShipmentCreatePage />} />
            </Route>
            <Route path=":shipmentName" element={<ShipmentUpdate />} />
          </Route>
          <Route path="manage-company">
            <Route path=":companyId">
              <Route path="site-materials">
                <Route index element={<CompanySiteMaterials />} />
                <Route path=":siteMaterialId">
                  <Route path="update">
                    <Route index element={<SiteMaterialUpdate />} />
                  </Route>
                </Route>
                <Route path="new" element={<NewSiteMaterial />} />
              </Route>
              <Route
                path="material-specifications"
                element={
                  <Suspense fallback={<CenteredLoader />}>
                    <Outlet />
                  </Suspense>
                }
              >
                <Route index element={<BuyerMaterialSpecificationsListPage />} />
                <Route path=":buyerMaterialSpecificationId" element={<BuyerMaterialSpecificationsEditPage />} />
                <Route path="new" element={<BuyerMaterialSpecificationsAddPage />} />
              </Route>
            </Route>
            <Route path="*" element={<ErrorDetails error={notFoundError()} homeHref="/ground-control" />} />
          </Route>
        </Route>
        <Route path="evidence">
          <Route path=":evidenceId" element={<PhotoEvidenceView />} />
        </Route>
        <Route path="copy-sessions" element={<CopySessions />} />
      </Route>

      <Route
        path="/post-deal/"
        element={
          <Layout>
            <Outlet />
          </Layout>
        }
      >
        <Route path="dealhub/deal/details/:deal_id/revenue/" element={<DealRevenueDetails />} />

        <Route path="dealhub/deal/details/:deal_id/cost/" element={<DealCostDetails />} />
      </Route>

      <Route
        path="support/ticket/"
        element={
          <Layout>
            <SupportTicketCreate />
          </Layout>
        }
      />
      <Route
        path="tickets/find/"
        element={
          <Layout>
            <FindTickets />
          </Layout>
        }
      />

      <Route
        path="quality"
        element={
          <Layout>
            <Suspense fallback={<CenteredLoader />}>
              <NetworkStatusProvider>
                <Outlet />
              </NetworkStatusProvider>
            </Suspense>
          </Layout>
        }
      >
        <Route path="external-evidence" element={<ExternalEvidence />} />
        <Route path="*" element={<ErrorDetails error={notFoundError()} homeHref="/ground-control" />} />
      </Route>

      <Route path="accounts">
        <Route path="auth">
          <Route path="sign-in">
            <Route index element={<SignInEmail />} />
            <Route path="email">
              <Route index element={<SignInEmail />} />
              <Route path="verify" element={<SignInEmailVerify />} />
            </Route>
            <Route path="phone">
              <Route index element={<SignInPhone />} />
              <Route path="verify" element={<SignInPhoneVerify />} />
            </Route>
          </Route>
          <Route path="sign-up">
            <Route index element={<SignUp />} />
            <Route path="verify" element={<SignUpVerify />} />
            <Route path="company" element={<SignUpCompany />} />
            <Route path="success" element={<SignUpSuccess />} />
          </Route>

          <Route path="*" element={<ErrorDetails error={notFoundError()} homeHref="/accounts/auth/sign-in" />} />
        </Route>
      </Route>
    </Routes>
  );
};
